import { gql } from '@apollo/client'

export const GET_FEATURE_FLAG = gql`
  query FeatureFlag($name: String!) {
    featureFlag(name: $name) {
      name
      isEnabled
    }
  }
`

export const GET_FEATURE_FLAG_INT_VALUE = gql`
  query FeatureFlagIntValue($name: String!, $defaultValue: Int!) {
    featureFlagIntValue(name: $name, defaultValue: $defaultValue)
  }
`
